<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title text-uppercase m-0 c-body2 text-center">
        {{ $t("cancellationPolicy") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18">
          {{ $t("policyObj.text1") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text2") }}
        </p>
        <div class="table-facility full-width mt-20">
          <table class="full-width" border>
            <thead>
              <tr>
                <th>STT</th>
                <th>TÊN SÂN GOLF</th>
                <th>HOÀN/HỦY</th>
              </tr>
            </thead>
            <tbody>
              <tr class="full-width c-white" style="background-color: #0265a6;">
                <td></td>
                <td>MIỀN BẮC</td>
                <td></td>
              </tr>
              <tr v-for="item in golfClubs" :key="item.stt">
                <td>{{ item.stt }}</td>
                <td class="fw-500">{{ item.name }}</td>
                <td>
                  <p
                    class="m-0 p-0"
                    v-for="(p, i) in item.refundPolicy"
                    :key="i"
                  >
                    {{ p.condition }} {{ p.time }}
                  </p>
                </td>
              </tr>
              <tr class="full-width c-white" style="background-color: #0265a6;">
                <td></td>
                <td>MIỀN TRUNG</td>
                <td></td>
              </tr>
              <tr v-for="(item, index) in golfClubsCentral" :key="item.stt">
                <td>{{ index + 1 }}</td>
                <td class="fw-500">{{ item.name }}</td>
                <td>
                  <p
                    class="m-0 p-0"
                    v-for="(p, i) in item.refundPolicy"
                    :key="i"
                  >
                    {{ p.condition }} {{ p.time }}
                  </p>
                </td>
              </tr>
              <tr class="full-width c-white" style="background-color: #0265a6;">
                <td></td>
                <td>NHA TRANG</td>
                <td></td>
              </tr>
              <tr v-for="(item, index) in golfClubsNT" :key="item.stt">
                <td>{{ index + 1 }}</td>
                <td class="fw-500">{{ item.name }}</td>
                <td>
                  <p
                    class="m-0 p-0"
                    v-for="(p, i) in item.refundPolicy"
                    :key="i"
                  >
                    {{ p.condition }} {{ p.time }}
                  </p>
                </td>
              </tr>
              <tr class="full-width c-white" style="background-color: #0265a6;">
                <td></td>
                <td>MIỀN NAM</td>
                <td></td>
              </tr>
              <tr v-for="(item, index) in golfClubsSouth" :key="item.stt">
                <td>{{ index + 1 }}</td>
                <td class="fw-500">{{ item.name }}</td>
                <td>
                  <p
                    class="m-0 p-0"
                    v-for="(p, i) in item.refundPolicy"
                    :key="i"
                  >
                    {{ p.condition }} {{ p.time }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-payment",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("cancellationPolicy"),
        isShowHomeIcon: true,
        isShowMenu: true
      },
      golfClubs: [
        {
          stt: 1,
          name: "Sky Lake Resort & Golf Club SKY",
          refundPolicy: [
            { condition: "- 1 flight:", time: "trc 24h" },
            { condition: "- 2 flights:", time: "trc 48h" },
            { condition: "- Từ 3 flights:", time: "trc 72h" }
          ]
        },
        {
          stt: 2,
          name: "Sky Lake Resort & Golf Club LAKE (Chỉ nhận member)",
          refundPolicy: [
            { condition: "- 1 flight:", time: "trc 24h" },
            { condition: "- 2 flights:", time: "trc 48h" },
            { condition: "- Từ 3 flights:", time: "trc 72h" }
          ]
        },
        {
          stt: 3,
          name: "Long Bien Golf",
          refundPolicy: [{ time: "Trước 24h" }]
        },
        {
          stt: 4,
          name: "Hanoi Minh Tri Golf",
          refundPolicy: [{ time: "T2-T6: Trước 24h | T7-CN: Trước 48h" }]
        },
        {
          stt: "5-7",
          name: "BRG Kings Island Golf Resort (Kings - Lake - Mountain)",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 5,
          name: "BRG Kings Island Golf Resort - Kings",
          refundPolicy: [
            { condition: "SL <12 pax:", time: "Trước 48h" },
            { condition: "SL > 12 pax:", time: "8 ngày" }
          ]
        },
        {
          stt: 6,
          name: "BRG Kings Island Golf Resort - Lake",
          refundPolicy: [
            { condition: "SL <12 pax:", time: "Trước 48h" },
            { condition: "SL > 12 pax:", time: "8 ngày" }
          ]
        },
        {
          stt: 7,
          name: "BRG Kings Island Golf Resort - Mountain",
          refundPolicy: [
            { condition: "SL <12 pax:", time: "Trước 48h" },
            { condition: "SL > 12 pax:", time: "8 ngày" }
          ]
        },
        {
          stt: 8,
          name: "BRG Legend Hill Golf Resort",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 9,
          name: "BRG Legend Valley Country Club (Hà Nam)",
          refundPolicy: [
            { condition: "<12 pax:", time: "trước 48h" },
            { time: "(trong vòng 24h: 100%, trước 24h, trong vòng 48h: 50%)" },
            { condition: ">12 pax:", time: "trước 6 ngày" }
          ]
        },
        {
          stt: 10,
          name: "Van Tri Golf Club (chỉ nhận member) không xe điện",
          refundPolicy: [{ time: "Check case by case" }]
        },
        {
          stt: 11,
          name: "Tam Dao Golf Resort",
          refundPolicy: [{ time: "T2-T6: Trước 2h | T7-CN: Trước 60h" }]
        },
        {
          stt: 12,
          name: "Dai Lai Star Golf & Country Club",
          refundPolicy: [
            { condition: "Hủy:", time: "Trước 24h" },
            { condition: "Đổi tên:", time: "Trước 2h" }
          ]
        },
        {
          stt: 13,
          name: "Heron Lake (Đầm Vạc) Golf",
          refundPolicy: [
            {
              time:
                "Trước 24h trước 0h của NGÀY chơi (không phải trước 24h teetime)"
            }
          ]
        },
        {
          stt: 14,
          name: "Thanh Lanh Valley Golf & Resort",
          refundPolicy: [
            { condition: "T2-T6: 1-8 pax:", time: "Trước 48h" },
            { condition: "9-19 pax:", time: "Trước 72h" },
            { condition: "T7-CN: 1-8 pax:", time: "Trước 72h" },
            { condition: "9-19 pax:", time: "trước 120h" }
          ]
        },
        {
          stt: 15,
          name: "Phoenix Golf Resort (Lương Sơn)",
          refundPolicy: []
        },
        {
          stt: 16,
          name: "Hilltop Valley Golf Club",
          refundPolicy: [
            { condition: "Hủy:", time: "* WD: 2 giờ, * WK: 12 giờ" },
            { time: "- Gửi booking trước: WD: 2h, WK: 12h" }
          ]
        },
        {
          stt: 17,
          name: "Stone Valley Golf Resort (Kim Bảng)",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 18,
          name: "Chí Linh Star Golf (TẶNG D50)",
          refundPolicy: [{ time: "Trước 120h" }]
        },
        {
          stt: 19,
          name: "Trang An Ninh Binh Golf",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 20,
          name: "Royal Golf Course (Yên Thắng)",
          refundPolicy: [
            { condition: "Sân King", time: "Trước 48h" },
            { condition: "Sân King + Queen", time: "Trước 48h" }
          ]
        },
        {
          stt: 21,
          name: "Dragon Golf Links (TẶNG E50)",
          refundPolicy: [{ time: "72h" }]
        },
        {
          stt: 22,
          name: "Vinpearl Golf Hai Phong (Hải An - Hải Phòng)",
          refundPolicy: [{ time: "Trước 3 ngày" }]
        },
        {
          stt: 23,
          name: "Sono Belle Hải Phòng - Sông Giá",
          refundPolicy: [{ time: "48h" }]
        },
        {
          stt: 24,
          name: "BRG Ruby Tree Do Son Golf",
          refundPolicy: [
            {
              condition: "Dưới 12 pax",
              time: "24h-48h: phạt 50%, Trước 24h: 100%"
            },
            {
              condition: "Trên 12 pax",
              time: "Trước 7 ngày: phạt 50%, 6 ngày - 3 ngày: 75%, 3 ngày: 100%"
            }
          ]
        },
        {
          stt: 25,
          name: "Tuần Châu",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 26,
          name: "FLC Halong Bay Golf Club & Luxury Resort",
          refundPolicy: [{ time: "96h" }]
        },
        {
          stt: 27,
          name: "Mong Cai International Golf",
          refundPolicy: [{ time: "24h" }]
        },
        {
          stt: 28,
          name: "Amber Hills Golf & Resort (Yên Dũng)",
          refundPolicy: [{ time: "24h" }]
        },
        {
          stt: 29,
          name:
            "Stone Highland Golf & Resort (Việt Yên)  - Lưu ý: chính sách phạt nếu noshow (hoãn hủy)",
          refundPolicy: [
            { condition: "hoãn hủy", time: "72 tiếng, đổi tên trước 2 tiếng" },
            { condition: "- trên 72h", time: "50%" },
            { condition: "- từ 24h01 phút đến 72h", time: "100%" },
            { condition: "- dưới 24h", time: "120%" }
          ]
        },
        {
          stt: 30,
          name: "Yen Bai Star Golf",
          refundPolicy: []
        },
        {
          stt: 31,
          name: "Sapa Grand Golf Course",
          refundPolicy: [{ time: "1 ngày" }]
        },
        {
          stt: 32,
          name: "Corn Hill Golf & Resort",
          refundPolicy: [
            {
              condition: "Booking chơi ngày trong tuần",
              time: "Trước 24 giờ (01 ngày) kể từ giờ Tee time tại Booking"
            },
            {
              condition: "Booking chơi ngày cuối tuần, ngày lễ",
              time: "Trước 48 giờ (02 ngày) kể từ giờ Tee time tại Booking"
            }
          ]
        },
        {
          stt: 33,
          name: "Văn Lang Empire T&T Golf Club (check case by case với TTVH)",
          refundPolicy: [
            {
              time:
                "Quy định thanh toán và hoãn huỷ: Trước 24h so với giờ tee time ngày thường và trước 48h so với giờ tee time cuối tuần"
            }
          ]
        }
      ],
      golfClubsCentral: [
        // Existing entries (1-33)

        // New entries (FLC, Mường Thanh, etc.)
        {
          stt: 34,
          name: "FLC Samson Golf",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 35,
          name: "FLC Quy Nhon Golf",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 36,
          name: "FLC Quang Binh Golf Links",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 37,
          name: "Mường Thanh Golf Club Xuan Thanh (Ha Tinh)",
          refundPolicy: [{ time: "Trước 24h" }]
        },
        {
          stt: 38,
          name: "Muong Thanh Golf Club Diễn Lâm (Nghệ An)",
          refundPolicy: [{ time: "Trước 24h" }]
        },
        {
          stt: 39,
          name: "Cua Lo Golf",
          refundPolicy: [{ time: "Trước 24h" }]
        },
        {
          stt: 40,
          name: "Golden Sands Golf Resort (áp dụng đến 27/11/2024)",
          refundPolicy: [
            { condition: "SL <12 pax", time: "Trước 48h" },
            { condition: "SL > 12 pax", time: "Trước 8 ngày" }
          ]
        }
      ],
      golfClubsNT: [
        {
          stt: 41,
          name: "Vinpearl Golf Nha Trang",
          refundPolicy: [{ time: "Trước 3 ngày" }]
        },
        {
          stt: 42,
          name: "Diamond Bay Golf NHA TRANG",
          refundPolicy: [{ time: "Trước 30 ngày" }]
        },
        {
          stt: 43,
          name: "KN Golf Link (Cam Ranh) NHA TRANG",
          refundPolicy: [{ time: "Trước 7 ngày" }]
        },
        {
          stt: 44,
          name: "Nara Bình Tiên",
          refundPolicy: [
            { condition: "Dưới 12 pax:" },
            { condition: "- Trong tuần trước 48h" },
            { condition: "- Cuối tuần trước 72h" },
            { condition: "Trên 12 pax:", time: "Trước 5 ngày" }
          ]
        }
      ],
      golfClubsSouth: [
        {
          stt: 45,
          name: "Vinpearl Golf Phú Quốc",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 46,
          name: "Tan Son Nhat Golf Course",
          refundPolicy: [
            { condition: "T2-T6", time: "Trước 24h" },
            { condition: "T7-CN", time: "Trước 48h" }
          ]
        },
        {
          stt: 47,
          name: "Vietnam Golf & Country Club",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 48,
          name:
            "West Lakes Golf & Villa (Giá đại lí áp dụng từ 2 khách trở lên)",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 49,
          name: "Royal Long An Golf & Villas",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 50,
          name: "Twin Doves Golf",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 51,
          name: "Harmonie Golf Park",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 52,
          name: "Royal Island Golf",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 53,
          name: "Song Be Golf Resort",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 54,
          name: "Taekwang Jeongsan Country Club",
          refundPolicy: [{ time: "Trước 96h" }]
        },
        {
          stt: 55,
          name: "Long Thanh Golf Resort",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 56,
          name: "Dong Nai Golf",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 57,
          name: "Eschuri Vung Bau",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 58,
          name: "Dalat Palace Golf",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 59,
          name: "Sacom Golf Club",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 60,
          name: "Dalat at 1200 Golf",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 61,
          name: "PGA Novaworld Phan Thiết",
          refundPolicy: [{ time: "Trước 7 ngày" }]
        },
        {
          stt: 62,
          name: "Sea Links Golf",
          refundPolicy: [{ time: "Trước 72h" }]
        },
        {
          stt: 63,
          name: "The Bluffs Ho Tram Golf",
          refundPolicy: [{ time: "Trước 7 ngày" }]
        },
        {
          stt: 64,
          name: "Vung Tau Paradise Golf",
          refundPolicy: [{ time: "Trước 48h" }]
        },
        {
          stt: 65,
          name: "Sonadezi Chau Duc Golf Course",
          refundPolicy: [{ time: "Trước 48h" }]
        }
      ]
    };
  },
  created() {}
};
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 14px;
  text-align: left;
}
th,
td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: center;
}
th {
  background-color: #0265a6;
  color: white;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
td {
  font-size: 12px;
}
td p {
  font-size: 12px;
}
tr:hover {
  background-color: #f1f1f1;
}
caption {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
